import { LinkTypesEnum } from '../../../Common/PageBuilder/enums/link-types.enum';

export enum WireSocialLinkEnum {
    WEBSITE = 'WEBSITE',
    FACEBOOK = 'FACEBOOK',
    TWITTER = 'TWITTER',
    LINKEDIN = 'LINKEDIN',
    INSTAGRAM = 'INSTAGRAM',
    YOUTUBE = 'YOUTUBE',
    SNAPCHAT = 'SNAPCHAT',
    TIKTOK = 'TIKTOK'
}

export const wireLinkTypesToLabelStrings = {
    [WireSocialLinkEnum.TWITTER]: 'X',
    [WireSocialLinkEnum.FACEBOOK]: 'Facebook',
    [WireSocialLinkEnum.INSTAGRAM]: 'Instagram',
    [WireSocialLinkEnum.YOUTUBE]: 'YouTube',
    [WireSocialLinkEnum.LINKEDIN]: 'LinkedIn',
    [WireSocialLinkEnum.SNAPCHAT]: 'Snapchat',
    [WireSocialLinkEnum.TIKTOK]: 'TikTok',
    [WireSocialLinkEnum.WEBSITE]:  'Website',
};

export const wireSocialLinkTypeToLinkTypeEnum = {
    [WireSocialLinkEnum.TWITTER]: LinkTypesEnum.twitter,
    [WireSocialLinkEnum.FACEBOOK]: LinkTypesEnum.facebook,
    [WireSocialLinkEnum.INSTAGRAM]: LinkTypesEnum.instagram,
    [WireSocialLinkEnum.YOUTUBE]: LinkTypesEnum.youtube,
    [WireSocialLinkEnum.LINKEDIN]: LinkTypesEnum.linkedin,
    [WireSocialLinkEnum.SNAPCHAT]: LinkTypesEnum.snapchat,
    [WireSocialLinkEnum.TIKTOK]: LinkTypesEnum.tiktok,
    [WireSocialLinkEnum.WEBSITE]:  LinkTypesEnum.website,
};

export const linkTypeEnumToWireSocialLinkType = {
    [LinkTypesEnum.twitter]: WireSocialLinkEnum.TWITTER,
    [LinkTypesEnum.facebook]: WireSocialLinkEnum.FACEBOOK,
    [LinkTypesEnum.instagram]: WireSocialLinkEnum.INSTAGRAM,
    [LinkTypesEnum.youtube]: WireSocialLinkEnum.YOUTUBE,
    [LinkTypesEnum.linkedin]: WireSocialLinkEnum.LINKEDIN,
    [LinkTypesEnum.snapchat]: WireSocialLinkEnum.SNAPCHAT,
    [LinkTypesEnum.tiktok]: WireSocialLinkEnum.TIKTOK,
    [LinkTypesEnum.website]: WireSocialLinkEnum.WEBSITE,
};
